import { render, staticRenderFns } from "./successfulScreen.vue?vue&type=template&id=4704832e&scoped=true"
import script from "./successfulScreen.vue?vue&type=script&lang=js"
export * from "./successfulScreen.vue?vue&type=script&lang=js"
import style0 from "./successfulScreen.vue?vue&type=style&index=0&id=4704832e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704832e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
